import { ApolloLink } from '@apollo/client'

export const versionCheckLink = new ApolloLink((operation, forward) => {
	return forward(operation).map((data) => {
		const { response } = operation.getContext()
		const serverVersion = response?.headers?.get?.('x-ui-version')
		const clientVersion = import.meta.env.VITE_APP_GIT_SHA

		if (serverVersion && clientVersion && serverVersion !== clientVersion) {
			// we do a hard reload, in most case the url will already be updated
			// before the graphql response is received, so the user will be redirected to the correct version of the app
			window.location.reload()
		}
		return data
	})
})
